import { render, staticRenderFns } from "./TopicForm.vue?vue&type=template&id=b61cb90a&scoped=true"
import script from "./TopicForm.vue?vue&type=script&lang=js"
export * from "./TopicForm.vue?vue&type=script&lang=js"
import style0 from "./TopicForm.vue?vue&type=style&index=0&id=b61cb90a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../.yarn/__virtual__/vue-loader-virtual-45869d479f/4/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61cb90a",
  null
  
)

export default component.exports